"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components")); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var getIconSize = function getIconSize(p) {
  switch (p.size) {
    case 'small':
      return p.theme.tokens.iconSizeSmall;

    case 'large':
      return p.theme.tokens.iconSizeLarge;

    case 'x-large':
      return p.theme.tokens.iconSizeXLarge;

    default:
      return p.theme.tokens.iconSizeDefault;
  }
};

var Icon = /*#__PURE__*/_styledComponents["default"].svg.withConfig({
  // Prevent props being passed to svg element when using `as`
  shouldForwardProp: function shouldForwardProp(prop, defaultValidator) {
    return !['size', 'inline'].includes(prop) && defaultValidator(prop);
  }
}).withConfig({
  displayName: "Icon",
  componentId: "sc-1xxxh51-0"
})(["vertical-align:text-bottom;width:", ";height:", ";margin-right:", ";"], function (p) {
  return getIconSize(p);
}, function (p) {
  return getIconSize(p);
}, function (p) {
  return p.inline ? p.theme.tokens.spacing03 : 0;
});

Icon.propTypes = {
  size: (0, _propTypes.oneOf)(['small', 'default', 'large', 'x-large']),
  inline: _propTypes.bool
};
Icon.defaultProps = {
  size: 'default',
  inline: false
};
var _default = Icon;
exports["default"] = _default;